import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../locales/en";

export const DEFAULT_LANGUAGE = "en";
export const FALLBACK_LANGUAGE = "en";

export const SUPPORTED_LANGUAGES = {
  en: "English",
} as const;

const getBrowserLanguage = (): string => {
  const browserLang = navigator.language.split("-")[0];

  return browserLang && browserLang in SUPPORTED_LANGUAGES
    ? browserLang
    : DEFAULT_LANGUAGE;
};

export const initializeI18n = (): void => {
  void i18n.use(initReactI18next).init({
    resources: {
      en,
    },
    lng: getBrowserLanguage(),
    fallbackLng: FALLBACK_LANGUAGE,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });
};
